import { render, staticRenderFns } from "./absensisiswa.vue?vue&type=template&id=16a35707&"
import script from "./absensisiswa.vue?vue&type=script&lang=js&"
export * from "./absensisiswa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports